import getWorkflowRuns from "features/adminDashboard/actions/update/update.getWorkflowRuns";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "services/redux/rootReducer";
import styled from "styled-components";

const WORKFLOW_FETCH_FREQUENCY = 2000; //ms

const LogContainer: React.FC = () => {
    const dispatch = useDispatch();
    const [logs, setLogs] = useState<any>();

    const handleGetWorkflows = useCallback(async () => {
        const response = await dispatch(getWorkflowRuns());
        setLogs(response);
    }, [dispatch]);

    const displayedLogs = useMemo(() => {
        if (!logs) return;

        const processedLogs: Array<{
            id: string;
            created_at: string;
            status: string;
        }> = logs.workflow_runs.map((workflowRun: any) => {
            const { id, created_at, status } = workflowRun;
            return { id, created_at, status };
        });

        const displayedElements = processedLogs
            .sort((a, b) => {
                return (
                    (new Date(b.created_at) as any) -
                    (new Date(a.created_at) as any)
                );
            })
            .map(({ id, status, created_at }) => {
                return (
                    <LogEntry status={status} key={id + created_at}>
                        <span>{`${new Date(
                            created_at
                        ).toLocaleString()}`}</span>
                        <span>{status}</span>
                    </LogEntry>
                );
            });

        return displayedElements;
    }, [logs]);

    useEffect(() => {
        handleGetWorkflows();
        const interval = setInterval(
            handleGetWorkflows,
            WORKFLOW_FETCH_FREQUENCY
        );
        return () => {
            clearInterval(interval);
        };
    }, [handleGetWorkflows]);

    return (
        <Container>
            <HeaderTab />
            <Logs>{displayedLogs}</Logs>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-flow: column;
    box-shadow: 1px 0px 10px 1px rgba(0, 26, 255, 0.1);

    width: 80%;

    & > * {
        width: 100%;

        &:first-child {
            flex: 1;
            border-radius: 0.2rem 0.2rem 0 0;
        }
        &:last-child {
            flex: 4 1 auto;
            overflow-y: auto;
            height: 0px;
            border-radius: 0 0 0.2rem 0.2rem;
        }
    }

    @media (max-width: 768px) {
        min-height: 8rem;
    }
`;

const HeaderTab = styled.div`
    background: ${(props) => props.theme.colors.primary[50]};
`;

const Logs = styled.div`
    background: ${(props) => props.theme.colors.neutral[50]};
    color: ${(props) => props.theme.colors.primary[100]};
    padding: 0.25rem 0.75rem;

    display: flex;
    flex-flow: column;
`;

const LogEntry = styled.div<{ status: string }>`
    &:not(:first-child) {
        opacity: 0.3;
    }

    padding: 0.25rem 0;
    border-bottom: solid 0.05rem ${(props) => props.theme.colors.primary[50]};

    & > * {
        // time
        &:first-child {
        }
        // status
        &:last-child {
            font-weight: ${(props) => props.theme.fontWeight.bolder};
            font-size: 0.9em;
            color: ${(props) =>
                props.theme.colors.deploymentStatus[props.status] ||
                props.theme.colors.primary[100]};
        }
    }

    user-select: none;

    display: flex;
    justify-content: space-between;
`;

export default LogContainer;
